export default {
  locize: {
    PROJECTID: `921c72df-62e9-4f61-8cb8-88e466b4bff4`,
    REFERENCELANGUAGE: `de`,
    namespace: {
      GENERAL: `cookie-notice-ufe`,
      LIST: `cookie-notice-list`,
    },
  },
  version: {
    hash: {
      salt: `1`,
    },
  },
};
